import { appInstance } from './helpers/instance';
import App from './App.vue';

appInstance(App, '#root');
